<template>
  <v-container fluid class="ta-page">
    <v-card class="ta-card" flat>
      <!-- Header -->
      <div class="ta-title">My Time Attendance</div>
      <div class="ta-subtitle">View your check-in and check-out history.</div>

      <!-- Filters -->
      <v-row class="mt-4" align="end" dense>
        <v-col cols="12" sm="6" md="2">
          <div class="ta-label">From</div>
          <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computeddatefromFormatted" prepend-inner-icon="mdi-calendar-blank-outline"
                readonly v-bind="attrs" v-on="on" outlined dense hide-details class="ta-input"></v-text-field>
            </template>
            <v-date-picker v-model="datefrom" @input="menu = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <div class="ta-label">To</div>
          <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computeddateToFormatted" prepend-inner-icon="mdi-calendar-blank-outline"
                readonly v-bind="attrs" v-on="on" outlined dense hide-details class="ta-input"></v-text-field>
            </template>
            <v-date-picker v-model="dateto" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
            placeholder="Search date, location, or status..." outlined dense hide-details clearable
            class="ta-input"></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-md-end" style="gap: 12px">
          <v-btn depressed height="40" class="ta-btn-primary" @click="searchdata()">
            <v-icon left>mdi-magnify</v-icon> Search
          </v-btn>
          <v-btn outlined height="40" class="ta-btn-outline" @click="clearSearch()">Clear</v-btn>
        </v-col>
      </v-row>

      <!-- Table -->
      <div class="ta-table-wrap mt-6">
        <v-data-table :search="search" :headers="headers" :items="rows" class="ta-table"
          :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :page.sync="page" :items-per-page="itemsPerPage"
          hide-default-footer @pagination="pagination = $event" no-data-text="No records">
          <template v-slot:item.status_label="{ item }">
            <span class="ta-chip" :class="statusClass(item.status_label)">
              <span class="ta-dot"></span>{{ item.status_label }}
            </span>
          </template>
          <template v-slot:item.location="{ item }">
            <span v-if="item.location" @click="openPreviewMaps(item.location)" class="description-text">
              {{ item.location }}
            </span>
            <span v-else class="ta-muted">-</span>
          </template>
          <template v-slot:item.check_in="{ item }">
            <span :class="{ 'ta-muted': item.check_in === '--:--' }">{{ item.check_in }}</span>
          </template>
          <template v-slot:item.check_out="{ item }">
            <span :class="{ 'ta-muted': item.check_out === '--:--' }">{{ item.check_out }}</span>
          </template>
          <template v-slot:item.working_hours="{ item }">
            <span :class="{ 'ta-muted': item.working_hours === '-' }">{{ item.working_hours }}</span>
          </template>
        </v-data-table>
      </div>

      <!-- Footer -->
      <div class="ta-footer">
        <div class="d-flex align-center" style="gap: 12px">
          <span class="ta-footer-text">Rows per page:</span>
          <v-select v-model="itemsPerPage" :items="[10, 20, 50, 100]" outlined dense hide-details
            style="max-width: 90px" @change="page = 1"></v-select>
        </div>
        <div class="d-flex align-center" style="gap: 24px">
          <span class="ta-footer-text">{{ rangeText }}</span>
          <v-pagination v-model="page" :length="pagination.pageCount || 1" :total-visible="5" color="#0f2a4a"
            class="ta-pagination"></v-pagination>
        </div>
      </div>

      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Advancelist.js";
import { tolocalestringnumber } from "../computing/tolocalestringnumber";
import unity from "@/unity/unity";
const moment = require("moment");

export default {
  name: "advance-list",
  data(vm) {
    return {
      sortBy: "dateshow",
      sortDesc: true,
      page: 1,
      itemsPerPage: 10,
      pagination: {},
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      search_status: "",
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Request", "Approve", "Reject"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      headers: [
        {
          text: "DATE",
          value: "dateshow",
          sort: (a, b) => new Date(a) - new Date(b),
        },
        { text: "DAY", value: "day", sortable: false },
        { text: "STATUS", value: "status_label", sortable: false },
        { text: "CHECK IN", value: "check_in", sortable: false },
        { text: "CHECK OUT", value: "check_out", sortable: false },
        { text: "WORKING HOURS", value: "working_hours", sortable: false },
        { text: "LOCATION ON CHECK IN", value: "location", sortable: false },
      ],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      jobTitle_list: [],
      searchCharge: null,
      searchChargeJob: null,
      searchEmp: [],
      delete_id: 0,
      dialogDeleteActivity: false,
    };
  },

  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.initialize();
  },
  components: {
    SuccessDialog,
  },
  beforeUpdate() { },
  computed: {
    // แปลงข้อมูลเดิมจาก API ให้มีคอลัมน์ตาม UI ใหม่ (ไม่แก้ข้อมูลต้นฉบับ)
    rows() {
      return (this.mDataArray || []).map((item) => {
        const times = this.extractTimes(item.timeshow);
        const checkIn = times[0] || null;
        const checkOut = times.length > 1 ? times[times.length - 1] : null;
        return {
          ...item,
          day: this.dayName(item.dateshow),
          status_label: item.statusshow || "No record",
          check_in: checkIn || "--:--",
          check_out: checkOut || "--:--",
          working_hours: this.workingHours(checkIn, checkOut),
        };
      });
    },
    rangeText() {
      const p = this.pagination;
      if (!p || !p.itemsLength) return "0 of 0";
      return `${p.pageStart + 1}–${p.pageStop} of ${p.itemsLength}`;
    },
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);
    // await this.loadCompanyMaster(comp_id);
    // await this.loadDepartmentMaster(comp_id);
    // await this.loadPositionMaster(comp_id);

    await this.loadAuthorize();
    await this.setStartAndEndOfMonth();

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
  },
  methods: {
    dayName(d) {
      const m = moment(d, ["YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY", moment.ISO_8601]);
      return m.isValid() ? m.format("ddd") : "-";
    },
    // ดึงเวลา HH:mm จากข้อความ timeshow เดิม (เวลาแรก = เข้า, เวลาสุดท้าย = ออก)
    extractTimes(text) {
      if (!text) return [];
      const found = String(text).match(/\b([01]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?\b/g) || [];
      return found.map((t) => t.substr(0, 5).padStart(5, "0"));
    },
    workingHours(inT, outT) {
      if (!inT || !outT) return "-";
      const [h1, m1] = inT.split(":").map(Number);
      const [h2, m2] = outT.split(":").map(Number);
      let mins = h2 * 60 + m2 - (h1 * 60 + m1);
      if (mins <= 0) return "-";
      return `${Math.floor(mins / 60)}h ${String(mins % 60).padStart(2, "0")}m`;
    },
    statusClass(s) {
      const v = String(s || "").toLowerCase();
      if (v.includes("no record")) return "ta-chip--grey";
      if (v.includes("late")) return "ta-chip--orange";
      if (v.includes("absent") || v.includes("missing")) return "ta-chip--red";
      if (v.includes("leave") || v.includes("holiday")) return "ta-chip--blue";
      return "ta-chip--green";
    },
    async clearSearch() {
      this.search = "";
      this.page = 1;
      this.$showLoader();
      await this.setStartAndEndOfMonth();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async setStartAndEndOfMonth() {
      const today = new Date();

      // วันที่ 1 ของเดือนนี้
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.datefrom = moment(startOfMonth).format("YYYY-MM-DD");

      // วันที่สุดท้ายของเดือนนี้
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.dateto = moment(endOfMonth).format("YYYY-MM-DD");

      await this.loaddata();
    },
    async loadAuthorize() {
      const res_get = await api.getSettingGroupMenu();
      // console.log("res loadAuthorize : ", JSON.stringify(res_get));
      this.authorize = res_get.data;
    },

    async loaddata() {
      const resData = await api.getAllCheckInOutByUserID(
        localStorage.getItem(server.USER_ID),
        this.datefrom,
        this.dateto,
      );

      // 🔍 Debug: ดูข้อมูลที่ได้จาก API

      this.dataAll = resData.data;
      this.mDataArray = resData.data;


      this.$hideLoader();
    },
    async searchdata() {
      this.$showLoader();
      const resData = await api.getAllCheckInOutByUserID(
        localStorage.getItem(server.USER_ID),
        this.datefrom,
        this.dateto,
      );


      this.dataAll = resData.data;
      this.mDataArray = resData.data;
      this.page = 1;
      this.$hideLoader();
    },
    openPreviewMaps(data) {
      // ใช้ Regular Expression เพื่อดึงพิกัดจากข้อมูล
      const regex = /([\d.-]+)\s*,\s*([\d.-]+)/;
      const matches = data.match(regex);

      if (matches) {
        const lat = matches[1]; // ละติจูด (latitude)
        const lng = matches[2]; // ลองจิจูด (longitude)

        // สร้าง URL สำหรับเปิด Google Maps ที่จุดเดียว
        const url = `https://www.google.com/maps?q=${encodeURIComponent(
          lat,
        )},${encodeURIComponent(lng)}`;
        window.open(url, "_blank");
      } else {
        console.error("ไม่พบพิกัดในข้อมูล");
      }
    },
  },
};
</script>

<style scoped>
.ta-page { background: #f4f6f9; }
.ta-card { border-radius: 12px !important; padding: 32px 36px; }
.ta-title { font-size: 28px; font-weight: 800; color: #0f2a4a; line-height: 1.2; }
.ta-subtitle { font-size: 14px; color: #6b7280; margin-top: 4px; }
.ta-label { font-size: 13px; color: #374151; margin-bottom: 6px; }
.ta-input >>> .v-input__slot { min-height: 44px !important; border-radius: 6px; }
.ta-btn-primary { background-color: #0f2a4a !important; color: #fff !important; text-transform: none !important; letter-spacing: 0 !important; font-weight: 600; padding: 0 22px !important; border-radius: 6px; }
.ta-btn-outline { border-color: #0f2a4a !important; color: #0f2a4a !important; text-transform: none !important; letter-spacing: 0 !important; font-weight: 600; padding: 0 24px !important; border-radius: 6px; }

.ta-table-wrap { border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; }
.ta-table >>> thead th { background: #eef1f5 !important; color: #1f2937 !important; font-size: 12px !important; font-weight: 700 !important; letter-spacing: 0.3px; height: 46px !important; }
.ta-table >>> tbody td { font-size: 14px !important; color: #1f2937; height: 44px !important; }
.ta-table >>> tbody tr:hover { background: #f9fafb !important; }

.ta-chip { display: inline-flex; align-items: center; gap: 6px; padding: 3px 10px; border-radius: 4px; font-size: 12px; font-weight: 500; }
.ta-dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
.ta-chip--grey { background: #eef0f3; color: #4b5563; }
.ta-chip--green { background: #e7f6ec; color: #15803d; }
.ta-chip--orange { background: #fff4e5; color: #c2410c; }
.ta-chip--red { background: #fdecec; color: #b91c1c; }
.ta-chip--blue { background: #e8f0fe; color: #1d4ed8; }
.ta-muted { color: #9ca3af; }

.ta-footer { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; margin-top: 20px; }
.ta-footer-text { font-size: 14px; color: #374151; }
.ta-pagination >>> .v-pagination__item,
.ta-pagination >>> .v-pagination__navigation { box-shadow: none !important; border: 1px solid #d1d5db; border-radius: 6px !important; min-width: 36px; height: 36px; }
.ta-pagination >>> .v-pagination__item--active { background-color: #0f2a4a !important; border-color: #0f2a4a; color: #fff !important; }

.description-text {
  cursor: pointer !important;
  transition: color 0.3s ease !important;
  color: #1d4ed8;
}

.description-text:hover {
  color: #0f2a4a !important;
}
</style>